@use '../@shared/mixins' as *;
@use '../../styles/global' as *;

@layer kol-component {
	$base-horizontal-padding: to-rem(8);

	.kol-tree-item {
		--indentation: var(--tree-item-indentation, #{to-rem(10)}); // Set `--tree-item-indentation` in themes to control padding
		$root: &;

		&__link {
			.kol-link {
				display: inline-flex;
				min-height: var(--a11y-min-size);
				padding-right: to-rem(6);
				padding-left: max(calc((var(--indentation) * var(--level)) + $base-horizontal-padding), $base-horizontal-padding);
				align-items: center;

				text-decoration: none;
			}

			&--first-level .kol-link {
				padding-left: to-rem(6);
			}
		}

		&__link-inner {
			display: flex;
			align-items: center;
		}

		&__children {
			margin: 0;
			padding: 0;
			list-style: none;
		}

		.kol-span {
			place-items: unset; // unset 'center' style from global layer
		}

		&__toggle-button,
		&__toggle-button-placeholder {
			display: inline-flex;
			min-width: var(--a11y-min-size);
			min-height: var(--a11y-min-size);
			align-items: center;
			justify-content: center;
		}

		&__text {
			text-decoration: underline;
		}
	}
}
